import {
  TypedUseSelectorHook,
  useSelector as useSelectorRedux,
} from 'react-redux';
import { OwlStore } from '@owl-frontend/redux';
import dossierDetailsSlice from '../pages/dossier-details/data/logic';
import dossiersSlice from '../pages/dossiers/data/logic';
import insightsSlice from '../pages/insights/data/logic';
import usersSlice from '../pages/users/data/logic';
import localizationSlice from './localization/logic';
import sessionSlice from './session/logic';
import storeOptions from './storeOptions';
import tenantSlice from './tenant/logic';

const store = new OwlStore([], {}, storeOptions);
// pages
store.addSlice(dossierDetailsSlice);
store.addSlice(dossiersSlice);
store.addSlice(usersSlice);
store.addSlice(insightsSlice);
// meta
store.addSlice(localizationSlice);
store.addSlice(sessionSlice);
store.addSlice(tenantSlice);
export default store as OwlStore<any> as OwlStore<StoreState>;

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('../pages/dossier-details/data/logic', () =>
    store.addSlice(dossierDetailsSlice, true)
  );
  module.hot.accept('../pages/dossiers/data/logic', () =>
    store.addSlice(dossiersSlice, true)
  );
  module.hot.accept('../pages/users/data/logic', () =>
    store.addSlice(usersSlice, true)
  );
  module.hot.accept('../pages/insights/data/logic', () =>
    store.addSlice(insightsSlice, true)
  );
  module.hot.accept('./localization/logic', () =>
    store.addSlice(localizationSlice, true)
  );
  module.hot.accept('./session/logic', () =>
    store.addSlice(sessionSlice, true)
  );
  module.hot.accept('./tenant/logic', () => store.addSlice(tenantSlice, true));
  // // NOTE: if we self-register slices, in the slice's module, we would do the following:
  // if (process.env.NODE_ENV === 'development' && module.hot) {
  //   module.hot.accept()
  //   module.hot.dispose((data) => data.update = true)
  // }
  // store.addSlice(slice, module.hot?.data.update)
}

// NOTE: we could infer this from the `addSlice` operations, but imo it's
// better to explicitly state things. and we should infer it from the addSlice
// operations, but a few explicit things makes "go to definition" and other
// such things work nicer. also, it'll let us note the state if we move slices
// from being registered here to self-registering (and also allow
// hot-reloading stores?)
export interface StoreState {
  [dossierDetailsSlice.name]: (typeof dossierDetailsSlice)['initialState'];
  [dossiersSlice.name]: (typeof dossiersSlice)['initialState'];
  [localizationSlice.name]: (typeof localizationSlice)['initialState'];
  [sessionSlice.name]: (typeof sessionSlice)['initialState'];
  [usersSlice.name]: (typeof usersSlice)['initialState'];
  [insightsSlice.name]: (typeof insightsSlice)['initialState'];
  [tenantSlice.name]: (typeof tenantSlice)['initialState'];
}

export const useSelector: TypedUseSelectorHook<StoreState> = useSelectorRedux;
